import ProgressBar from 'components/ProgressBar'
import { TProgressProps } from 'types'

import { Text } from '@interco/inter-ui/components/Text'
import { interWbNavigate } from '@interco/inter-webview-bridge'

import * as S from './styles'

type TProps = {
  title: string
  progress?: TProgressProps
}

const Header = ({ title, progress }: TProps) => {
  const goBack = () => {
    interWbNavigate.requestGoBack()
  }

  return (
    <>
      <S.Header>
        <S.IArrowLeft onClick={goBack} />
        <Text variant="headline-h3" semiBold>
          {title}
        </Text>
        <div />
      </S.Header>
      {progress && <ProgressBar num={progress?.num} totalSteps={progress?.totalSteps} />}
    </>
  )
}

export default Header
